import React from 'react';
import { ArrowRightIcon } from './AppIcons';

const outcomes = [
  {
    stat: '01',
    title: 'Start with a mood',
    body: 'Hustle Dial treats energy as part of the workflow, so the session fits the state you are actually in.',
  },
  {
    stat: '15-180',
    title: 'Set a realistic pace',
    body: 'Fast presets make the next session easy to start, whether it is one focused sprint or a longer block.',
  },
  {
    stat: '14:51',
    title: 'Stay inside the session',
    body: 'The active timer keeps the interface reduced to what matters: remaining time, progress, and the next action.',
  },
  {
    stat: '47',
    title: 'Review every session',
    body: 'The ledger turns scattered attempts into a visible record of completed work, streaks, and total hours.',
  },
];

const BenefitsSection = () => {
  const scrollToSignup = () => {
    const section = document.getElementById('download');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="benefits" className="hd-section relative overflow-hidden">
      <div className="hd-radial hd-radial-center"></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid gap-12 lg:grid-cols-[1fr_0.85fr] lg:items-start">
          <div>
            <p className="hd-kicker text-lime">Why it works</p>
            <h2 className="hd-display text-5xl md:text-7xl text-bone leading-[0.95] mt-5 max-w-4xl">
              A focus system with a visible rhythm.
            </h2>
          </div>

          <div className="hd-ledger-note">
            <p className="hd-kicker text-hdInk">Product promise</p>
            <p className="hd-display text-4xl text-hdInk leading-none mt-4">
              Motivation is useful. Structure is what makes it repeatable.
            </p>
          </div>
        </div>

        <div className="mt-16 grid gap-4 md:grid-cols-2">
          {outcomes.map((outcome) => (
            <article key={outcome.title} className="hd-outcome">
              <div className="hd-outcome-stat">{outcome.stat}</div>
              <div>
                <h3 className="text-2xl md:text-3xl text-bone font-semibold tracking-tight">
                  {outcome.title}
                </h3>
                <p className="text-hdMuted leading-relaxed mt-4">
                  {outcome.body}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 hd-cta-strip">
          <div>
            <p className="hd-kicker text-lime">Available now</p>
            <h3 className="hd-display text-4xl md:text-5xl text-bone mt-3 leading-none">
              Ready to dial in your focus?
            </h3>
          </div>
          <button onClick={scrollToSignup} className="hd-pill hd-pill-lime">
            Download the App
            <ArrowRightIcon />
          </button>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
